module.exports = __webpack_public_path__ + "static/img/responseh5.2951232e.png";